import {
  BackstageIdentityApi, OpenIdConnectApi, ProfileInfoApi, SessionApi,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { SignInPage } from '@backstage/core-components';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import {
  ApiBlueprint, configApiRef, createApiRef, createFrontendModule,
  discoveryApiRef, oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';

const giteaAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>().with({ id: 'auth.hanmedia-gitea' });

const giteaAuthApi = ApiBlueprint.make({
  name: 'hanmedia-gitea',
  params: defineParams => defineParams({
    api: giteaAuthApiRef,
    deps: { configApi: configApiRef, discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef },
    factory: ({ configApi, discoveryApi, oauthRequestApi }) => OAuth2.create({
      configApi, discoveryApi, oauthRequestApi,
      environment: configApi.getOptionalString('auth.environment'),
      provider: { id: 'oidc', title: 'Gitea', icon: () => null },
      defaultScopes: ['openid', 'profile', 'email', 'public-only', 'read:user'],
    }),
  }),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => <SignInPage {...props} provider={{
      id: 'hanmedia-gitea', title: 'HanMedia Cockpit',
      message: 'Mit deinem freigegebenen Gitea-Konto anmelden.', apiRef: giteaAuthApiRef,
    }} />,
  },
});

export const giteaAuthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [giteaAuthApi, signInPage],
});
